module.exports = __webpack_public_path__ + "img/logo.45e2e581.png";